import React, { useContext, useEffect } from 'react';
import { Box } from '@mui/system';
import { List } from '@mui/material';
import { useQuery } from "@tanstack/react-query";

import UserContext from '@lib/contexts/userContext';
import { API_URLS, axiosRequest } from "@lib/axios";
import ActivityItem from './ActivityItem';

const ActivitiesList = ({setUserScore}) => {

  const { authenticated } = useContext(UserContext);

  const allActivitiesQuery = useQuery({
    queryKey: ['activities'],
    queryFn: () => axiosRequest({ method: 'GET', url: API_URLS.ACTIVITIES}),
    enabled: authenticated,
    refetchOnWindowFocus: false,
    retry: false,
  });
  if (allActivitiesQuery.isError) {
    console.log('ERROR fetching user activities', allActivitiesQuery.error);
  }

  const userActivitiesQuery = useQuery({
    queryKey: ['current_user', 'activities'],
    queryFn: () => axiosRequest({ method: 'GET', url: `${API_URLS.ACTIVITIES}/current-user`}),
    enabled: authenticated,
    refetchOnWindowFocus: false,
    retry: false,
  });
  if (userActivitiesQuery.isError) {
    console.log('ERROR fetching all activities', userActivitiesQuery.error);
  }

  const loading = allActivitiesQuery.isLoading || userActivitiesQuery.isLoading;

  return (
    <Box>
      {!loading &&
        <List sx={{
          paddingTop: 0,
          'li:first-of-type': { paddingTop: 0 },
          'li': { marginBottom: '10px', paddingRight: '15px' }
        }}>
          {allActivitiesQuery.data.map((activity) =>
            <ActivityItem
              key={activity.id}
              activity={activity}
              userActivities={userActivitiesQuery.data}
              setUserScore={setUserScore}
            />
          )}
        </List>
      }
    </Box>
  );
};

export default ActivitiesList;
